"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Plating = ({ pad, children, color }) => {
    // if(pad.pad_type == "")
    // "thru_hole" | "np_thru_hole" | "smd" | "connect";
    var _a, _b;
    switch (pad.shape) {
        case "oval":
            return react_1.default.createElement("rect", { x: (pad.at.x + (((_b = (_a = pad.drill) === null || _a === void 0 ? void 0 : _a.offset) === null || _b === void 0 ? void 0 : _b.x) || 0) - pad.size.width / 2), y: (pad.at.y - pad.size.height / 2), height: pad.size.height, width: pad.size.width, rx: Math.min(pad.size.width, pad.size.height) / 2, ry: Math.min(pad.size.width, pad.size.height) / 2, fill: color });
        case "circle":
            return react_1.default.createElement("circle", { cx: pad.at.x, cy: pad.at.y, r: pad.size.height / 2, fill: color }, children);
        case "rect":
            return react_1.default.createElement("rect", { x: (pad.at.x - pad.size.width / 2), y: (pad.at.y - pad.size.height / 2), width: pad.size.width, height: pad.size.height, fill: color }, children);
        case "trapezoid":
        case "roundrect":
        case "custom":
            return react_1.default.createElement("circle", { fill: 'red' });
    }
};
const Pad = ({ pad, color }) => {
    const main = (react_1.default.createElement(react_1.default.Fragment, null,
        pad.pad_type === "np_thru_hole" ? null : react_1.default.createElement(Plating, { pad: pad, color: color }),
        pad.drill ?
            react_1.default.createElement("rect", { x: (pad.at.x - pad.drill.width / 2), y: (pad.at.y - pad.drill.height / 2), width: pad.drill.width, height: pad.drill.height, rx: Math.min(pad.drill.width, pad.drill.height) / 2, ry: Math.min(pad.drill.width, pad.drill.height) / 2, fill: "black" })
            : null));
    const label = pad.id ? (react_1.default.createElement("text", { x: pad.at.x, y: pad.at.y, style: { fontSize: "1" }, dominantBaseline: "middle", textAnchor: "middle", className: "fonty", fill: "white" }, pad.id)) : null;
    // if(pad.at.angle) alert(`rotate(1 ${pad.at.x} ${pad.at.y})`)
    return (react_1.default.createElement(react_1.default.Fragment, null,
        pad.at.angle ?
            react_1.default.createElement("g", { transform: `rotate(${-pad.at.angle} ${pad.at.x} ${pad.at.y})` }, main) :
            main,
        label));
};
exports.default = Pad;
